{
    let scrollTargets = document.querySelectorAll('[data-timeline-target]');

    let activeElement = null;
    const offsetFromTop = 100;
    const visibleEntries = new Map();

    let observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    visibleEntries.set(entry.target, entry);
                } else {
                    visibleEntries.delete(entry.target);
                }
            });

            let topMostElement = null;
            let minTop = Infinity;

            visibleEntries.forEach((entry, element) => {
                if (entry.boundingClientRect.top <= offsetFromTop && entry.isIntersecting) {
                    if (entry.boundingClientRect.top < minTop) {
                        minTop = entry.boundingClientRect.top;
                        topMostElement = element;
                    }
                }
            });

            if (topMostElement && topMostElement !== activeElement) {
                if (activeElement) {
                    activeElement.classList.remove('is-active');
                }
                topMostElement.classList.add('is-active');
                activeElement = topMostElement;

            } else if (!topMostElement && activeElement) {
                if (window.scrollY === 0 && scrollTargets.length > 0) {
                     if (activeElement) {
                        activeElement.classList.remove('is-active');
                    }
                    scrollTargets[0].classList.add('is-active');
                    activeElement = scrollTargets[0];
                } else {
                    activeElement.classList.remove('is-active');
                    activeElement = null;
                }
            }
        },
        {
            threshold: [0, 0.1, 0.5, 0.9, 1],
            root: null,
            rootMargin: `-${offsetFromTop}px 0px 0px 0px`,
        }
    );

    if (scrollTargets !== null) {
        scrollTargets.forEach((el) => {
            observer.observe(el);
        });
    }
}

{
    let html_style = getComputedStyle(document.querySelector('html'));
    let scroll_padding = '0px';

    let observer = new IntersectionObserver(
        ([e]) => {
            let sel = e.target.getAttribute('id');
            let parent = document.querySelector(`[data-scroll-target=${sel}]`);

            if (parent == null) {
                return;
            }

            let siblings = [...parent.parentNode.children].filter((child) => child !== parent);

            siblings.forEach((el) => {
                el.classList.remove('is-active');
            });

            parent.classList.toggle('is-active', e.isIntersecting);
        },
        {
            threshold: [0],
            root: null,
            rootMargin: `-${scroll_padding}`,
        }
    );

    let targets = document.querySelectorAll('[data-scroll-target]');

    if (targets !== null) {
        targets.forEach((el) => {
            let sel = el.getAttribute('data-scroll-target');
            let parent = document.querySelector('#' + sel);

            if (parent == null) {
                return;
            }

            observer.observe(parent);
        });
    }
}
